import { createGlobalStyle } from 'styled-components';
import { darken, mix, rgba } from 'polished';
import colors from 'styles/colors.module.scss?export';
import { cssVariableNames } from 'theme/variables';
import {
  FOCUS_OPACITY,
  HOVER_OPACITY,
  HOVER_ACCENT_OPACITY,
  SEPARATOR_OPACITY,
  ACTIVE_DARKEN,
  BRAND_MIX_DISABLED_TEXT,
  HOVER_DARKEN,
  OPACITY_RELAXED_BASE,
  OPACITY_RELAXED_HOVER,
  OPACITY_RELAXED_ACTIVE,
  ACTIVE_OPACITY,
  ACTIVE_ACCENT_OPACITY,
  ACCENT_MIX_DISABLED_TEXT,
} from 'theme/constants';
import { isBackgroundLight } from 'utils/branding/brandingHelpers';

export const GlobalThemeVariables = createGlobalStyle`
  :root {
    /* Base Colors */
    ${cssVariableNames.colorBrand}: ${({ theme }) => theme.colors.brandColor};
    ${cssVariableNames.colorAccent}: ${({ theme }) => theme.colors.accentColor};

    /* Text */
    ${cssVariableNames.textBrand}: ${({ theme }) => theme.colors.textBrandColor};
    ${cssVariableNames.textAccent}: ${({ theme }) => theme.colors.textAccentColor};
    ${cssVariableNames.textDisabled}: ${({ theme }) =>
      mix(BRAND_MIX_DISABLED_TEXT, theme.colors.brandColor, colors.primary40)};
    ${cssVariableNames.textAccentDisabled}: ${({ theme }) =>
      mix(ACCENT_MIX_DISABLED_TEXT, theme.colors.accentColor, colors.primary40)};

      /* Backgrounds (States) */
    ${cssVariableNames.bgBrandHover}:
      ${({ theme }) => darken(HOVER_DARKEN, theme.colors.brandColor)};
    ${cssVariableNames.bgAccentHover}:
      ${({ theme }) => darken(HOVER_DARKEN, theme.colors.accentColor)};
    ${cssVariableNames.bgBrandActive}:
      ${({ theme }) => darken(ACTIVE_DARKEN, theme.colors.brandColor)};
    ${cssVariableNames.bgAccentActive}:
      ${({ theme }) => darken(ACTIVE_DARKEN, theme.colors.accentColor)};
    ${cssVariableNames.bgAccentDisabled}: ${() => colors.primary6};
    ${cssVariableNames.bgDisabled}: ${() => colors.primary6};

    /* States (Opacity overlays) */
    ${cssVariableNames.colorBrandFocus}:
      ${({ theme }) => rgba(theme.colors.brandColor, FOCUS_OPACITY)};
    ${cssVariableNames.colorBrandActive}:
      ${({ theme }) => rgba(theme.colors.brandColor, ACTIVE_OPACITY)};
    ${cssVariableNames.colorBrandHover}:
      ${({ theme }) => rgba(theme.colors.brandColor, HOVER_OPACITY)};
    ${cssVariableNames.colorAccentHover}:
      ${({ theme }) => rgba(theme.colors.accentColor, HOVER_ACCENT_OPACITY)};
    ${cssVariableNames.colorAccentActive}:
      ${({ theme }) => rgba(theme.colors.accentColor, ACTIVE_ACCENT_OPACITY)};

    /* Borders */
    ${cssVariableNames.borderSeparator}: ${({ theme }) => {
      const separatorColor = isBackgroundLight(theme.colors.brandColor)
        ? colors.black100Base
        : colors.primary10;

      return rgba(separatorColor, SEPARATOR_OPACITY);
    }};
    ${cssVariableNames.borderBrandFocus}: ${({ theme }) =>
      rgba(theme.colors.brandColor, FOCUS_OPACITY)};
    ${cssVariableNames.outlineFocus}: 2px solid ${colors.secondary40};
    ${cssVariableNames.outlineColor}: ${colors.secondary40};
    ${cssVariableNames.borderColor}: ${colors.primary10};

    /* Relaxed Button Backgrounds */
    ${cssVariableNames.bgAccentRelaxed}: ${({ theme }) =>
      rgba(theme.colors.accentColor, OPACITY_RELAXED_BASE)};
    ${cssVariableNames.bgAccentRelaxedHover}: ${({ theme }) =>
      rgba(theme.colors.accentColor, OPACITY_RELAXED_HOVER)};
    ${cssVariableNames.bgAccentRelaxedActive}: ${({ theme }) =>
      rgba(theme.colors.accentColor, OPACITY_RELAXED_ACTIVE)};
  }
`;
